import React, { useEffect } from 'react'

const SensorealWebfeed = () => {
  useEffect(() => {
    // Extract client name from host URL
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    let clientName = parts[0] === 'map' ? parts[1] : parts[0]; // Handle map.whiterock.com.au or whiterock.com.au
    clientName = clientName && clientName.toLowerCase();

    // // just for testing
    // clientName = 'mywhiterock';

    if (clientName === 'mywhiterock') {
      clientName = 'whiterock';
    }
    
    // Create and load the script
    const script = document.createElement('script');
    script.src = `https://assets.${clientName}.sensoreal.app/webconnect.js`;
    script.defer = true;
    script.onload = () => {
      if (window.initPropertyWebfeed) {
        window.initPropertyWebfeed('#webfeed', { mode: 'masterplan', type: 'land' });
      }
    };
    document.head.appendChild(script);

    // Add custom CSS for Sensoreal
    const style = document.createElement('style');
    style.textContent = `
      #webfeed {
        width: 100% !important;
        height: 100% !important;
      }
      
      #sensoreal {
        padding: 20px !important;
        margin: 0 auto !important;
      }
    `;
    document.head.appendChild(style);

    // Cleanup function to remove script and styles when component unmounts
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);

  return <div id="webfeed" style={{ width: '100%', height: '100%' }}></div>;
};

export default SensorealWebfeed; 